import { CREDIT_CARD, ROBO, ROBO_REJECTED, GBI, GBI_REJECTED, TRADITIONAL } from 'constants/userProfile';
import { COUNTRY_CODE_ES, COUNTRY_CODE_DE, COUNTRY_CODE_PT, COUNTRY_CODE_NL } from 'commonsConstants/countryCodes';
import {
    VIDEOCALLS_IN_1_BOX as VIDEOS_WITH_TABS_FLAG,
    TC_VIDEOCALL as TC_VIDEOCALL_FLAG,
    TC_VIDEOSELFIE as TC_VIDEOSELFIE_FLAG,
    TC_VIDEOS as TC_VIDEOS_FLAG,
    TC_IBAN as TC_IBAN_FLAG,
    TC_IBAN,
    ROBO_VIDEOS,
    ROBO_VIDEOCALL,
    ROBO_VIDEOSELFIE,
    ROBO_IBAN,
    ROBO_TRANSFER,
} from 'constants/featureFlagging';

export const CORREOS = 'correos';
export const COURIER = 'courier';
export const IBAN = 'iban';
export const OFFLINE = 'offline';
export const TRANSFER_CERTIFICATE = 'transfer_certificate';
export const VIDEO = 'video';
export const VIDEO_CALL = 'videocall';
export const VIDEO_SELFIE = 'unassisted_videocall';
export const CIRBE = 'tcCirbe';

/**
 * Recommended identification method.
 */
export const IDENTITY_METHODS_TAG_BY_COUNTRY = {
    [COUNTRY_CODE_ES]: [IBAN, TC_IBAN_FLAG],
    [COUNTRY_CODE_NL]: [TRANSFER_CERTIFICATE],
    [COUNTRY_CODE_PT]: [VIDEO_SELFIE],
    [COUNTRY_CODE_DE]: [TRANSFER_CERTIFICATE],
};

export const IDENTITY_VIDEOS_BY_INVESTMENT_TYPE = {
    [CREDIT_CARD]: [TC_VIDEOS_FLAG, TC_VIDEOCALL_FLAG, TC_VIDEOSELFIE_FLAG],
    [TRADITIONAL]: [VIDEOS_WITH_TABS_FLAG, VIDEO_SELFIE, VIDEO_CALL],
    [ROBO]: [ROBO_VIDEOS, ROBO_VIDEOSELFIE, ROBO_VIDEOCALL],
};

const TRADITIONAL_VIDEOS_FLAGS_POSITION = IDENTITY_VIDEOS_BY_INVESTMENT_TYPE[TRADITIONAL];

/**
 * Available identification methods.
 * NOTE: Subsceptible to backend flags.
 */
export const IDENTITY_METHODS_BY_COUNTRY = {
    [COUNTRY_CODE_ES]: {
        [CREDIT_CARD]: [TC_IBAN_FLAG, TC_VIDEOSELFIE_FLAG, TC_VIDEOCALL_FLAG],
        [TRADITIONAL]: [VIDEOS_WITH_TABS_FLAG, VIDEO_SELFIE, IBAN, VIDEO_CALL, TRANSFER_CERTIFICATE],

        [ROBO]: [
            TRANSFER_CERTIFICATE,
            ROBO_VIDEOS,
            ROBO_VIDEOSELFIE,
            ROBO_IBAN,
            ROBO_VIDEOCALL,
            ROBO_TRANSFER,
            COURIER,
        ],
    },
    [COUNTRY_CODE_NL]: {
        [TRADITIONAL]: [...TRADITIONAL_VIDEOS_FLAGS_POSITION, TRANSFER_CERTIFICATE],
    },
    [COUNTRY_CODE_PT]: {
        [TRADITIONAL]: [...TRADITIONAL_VIDEOS_FLAGS_POSITION, TRANSFER_CERTIFICATE],
    },
    [COUNTRY_CODE_DE]: {
        [TRADITIONAL]: [...TRADITIONAL_VIDEOS_FLAGS_POSITION, TRANSFER_CERTIFICATE],
    },
};

export const IBAN_INVESTMENT_TYPES = {
    [CREDIT_CARD]: TC_IBAN,
    [TRADITIONAL]: IBAN,
    [ROBO]: ROBO_IBAN,
    [ROBO_REJECTED]: IBAN,
    [GBI]: IBAN,
    [GBI_REJECTED]: IBAN,
};

export const TRANSFER_INVESTMENT_TYPES = {
    [CREDIT_CARD]: TRANSFER_CERTIFICATE,
    [TRADITIONAL]: TRANSFER_CERTIFICATE,
    [ROBO]: ROBO_TRANSFER,
    [ROBO_REJECTED]: TRANSFER_CERTIFICATE,
    [GBI]: TRANSFER_CERTIFICATE,
    [GBI_REJECTED]: TRANSFER_CERTIFICATE,
};

export const IBAN_TRANSFER_OTP_RETRY_OTP = 'retry';
export const IBAN_TRANSFER_OTP_SEND_OTP = 'send';
export const IBAN_TRANSFER_OTP_VALIDATE = 'otp';
export const IBAN_TRANSFER_OTP_STATUS = 'status';
